module.exports = __webpack_public_path__ + "static/img/computer-background.f6bb6f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/computer-background.jpg
// module id = fWHF
// module chunks = 1